import { createValidation } from '../../../utils/validation';
export const createComplaintTypeValidation = (fields) => { const validation = createValidation(fields); return { schema: validation.schema, validateData: validation.validateData, validateComplaintTypeData: validation.validateData, validateField: validation.validateField }; };
export default createComplaintTypeValidation;
